package org.example.project.registrierung

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.Serializable
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.booleanOrNull
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.decodeFromJsonElement
import kotlinx.serialization.json.jsonArray
import kotlinx.serialization.json.jsonObject
import kotlinx.serialization.json.jsonPrimitive
import kotlinx.serialization.json.put
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.w3c.fetch.Headers
import org.w3c.fetch.RequestInit

@Serializable
data class TrustedDevice(
    val id: String = "",
    val current: Boolean = false,
    val label: String = "",
    val mode: String = "",
    val createdAtMs: Double = 0.0,
    val lastUsedAtMs: Double = 0.0,
    val expiresAtMs: Double = 0.0,
    val userAgent: String = "",
    val clientIp: String = ""
)

object TrustedDevicesApi {
    private val json = Json { ignoreUnknownKeys = true }

    suspend fun load(api: String): List<TrustedDevice> {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/$api/trusted-devices-list",
            RequestInit(
                headers = authHeaders()
            )
        ).await()
        if (!response.ok) return emptyList()
        val root = runCatching { json.parseToJsonElement(response.text().await()).jsonObject }.getOrNull() ?: return emptyList()
        val devices = root["devices"]?.jsonArray ?: return emptyList()
        return runCatching { json.decodeFromJsonElement(ListSerializer(TrustedDevice.serializer()), devices) }.getOrDefault(emptyList())
    }

    suspend fun delete(api: String, deviceId: String): Boolean {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/$api/trusted-devices-delete",
            RequestInit(
                method = "POST",
                headers = authHeaders().apply { append("Content-Type", "application/json") },
                body = json.encodeToString(
                    buildJsonObject {
                        put("deviceId", deviceId)
                    }
                )
            )
        ).await()
        if (!response.ok) return false
        val root = runCatching { json.parseToJsonElement(response.text().await()).jsonObject }.getOrNull() ?: return false
        return root["ok"]?.jsonPrimitive?.booleanOrNull == true
    }

    suspend fun rename(api: String, deviceId: String, label: String): Boolean {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/$api/trusted-devices-rename",
            RequestInit(
                method = "POST",
                headers = authHeaders().apply { append("Content-Type", "application/json") },
                body = json.encodeToString(
                    buildJsonObject {
                        put("deviceId", deviceId)
                        put("label", label)
                    }
                )
            )
        ).await()
        if (!response.ok) return false
        val root = runCatching { json.parseToJsonElement(response.text().await()).jsonObject }.getOrNull() ?: return false
        return root["ok"]?.jsonPrimitive?.booleanOrNull == true
    }

    private fun authHeaders(): Headers = LumaticaApiManager.auditHeaders()
}
